<template>
  <div class="cont">
    <div class="home-banner">
      <b-carousel
        id="carousel-1"
        :interval="4000"
        controls
        indicators
        background="#ababab"
        img-width="50%"
        img-height="480"
        style="text-shadow: 1px 1px 2px #333"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <!-- Text slides with image -->
        <b-carousel-slide v-for="son in CarouselSlideList" v-bind:key="son.ID">
          <template v-slot:img>
            <template v-if="son.IsExternallinks">
              <a target="_blank" :href="son.GoUrl">
                <img
                  class="d-block img-fluid w-100"
                  width="50%"
                  height="480"
                  :src="son.FilePath"
                  alt="image slot"
                />
              </a>
            </template>
            <template v-else>
              <router-link v-bind:to="son.GoUrl" target="_blank">
                <img
                  class="d-block img-fluid w-100"
                  width="50%"
                  height="480"
                  :src="son.FilePath"
                  alt="image slot"
                />
              </router-link>
            </template>
          </template>
          <!-- <template v-slot:img>
            <img class="d-block img-fluid w-100" width="50%" height="480" :src="son.FilePath" alt="image slot" />
          </template> -->
          <div v-bind:class="[caption, son.PicName]">
            <div class="display">{{ son.Headline }}</div>
            <p>{{ son.Englishtitle }}</p>
            <h3>{{ son.Subhead }}</h3>
          </div>
        </b-carousel-slide>
      </b-carousel>
    </div>

    <section>
      <div style="padding: 0 10%; height: 440px; overflow: hidden;">
        <div style="display: flex; justify-content: space-between">
          <div style="width: 58%; position: relative">
            <el-carousel trigger="click" class="swiperDom">
                 <el-carousel-item>
                <img
                  style="width: 100%"
                  src="@/assets/img/homezdsys.png"
                  alt=""
                  @click="goPage('http://www.crecu.com/')"
                />
                <div class="home-yszt-tips" @click.stop>
              <div>自然资源部煤炭资源勘查与综合利用重点实验室</div>
              <div class="more">
                <a
                  @click="goPage('http://www.crecu.com/')"
                  target="_blank"
                  style="color: #fff"
                  >查看自然资源部煤炭资源勘查与综合利用重点实验室 ></a>
              </div>
            </div>
              </el-carousel-item>
              <el-carousel-item>
                <img style="width: 100%" src="@/assets/img/show-house.jpg" alt="" @click="goPage('https://www.coalgeocloud.com:8081')" />
                <div class="home-yszt-tips" @click.stop>
                  <div>煤炭地质云【云上展厅】，打破空间束缚，畅享虚拟现实。</div>
                  <div class="more">
                    <a href="https://www.coalgeocloud.com:8081" target="_blank" style="color: #fff" >查看云上展厅 ></a>
                  </div>
                </div>
                <div class="home-qr-code-box" @click.stop>
                <div style="color: #fff;text-align: right;margin-bottom: 2px;line-height: 2;font-size: 12px;">
                  <span style="display: inline-block;padding: 0 8px;background: rgba(0, 0, 0, 0.2);cursor: default;">手机扫码查看</span>
                </div>
              <div class="home-qr-code-inner">
                <div style="margin-bottom: 5px">
                  <img
                    style="width: 100%"
                    src="@/assets/img/yszt-code.png"
                    alt=""
                  />
                </div>
                <div class="more">云上展厅二维码</div>
              </div>
            </div>

            </el-carousel-item>

              <el-carousel-item>
                <img
                  style="width: 100%"
                  src="@/assets/img/house-map.jpg"
                  alt=""
                  @click="goPage('/ProjectOneDrawing')"
                />
                <div class="home-yszt-tips" @click.stop>
              <div>煤炭地质云【项目管理驾驶舱】</div>
              <div class="more">
                <a
                  @click="goPage('/ProjectOneDrawing')"
                  target="_blank"
                  style="color: #fff"
                  >查看驾驶舱 ></a
                >
              </div>
            </div>
              </el-carousel-item>
               <el-carousel-item>
                <img
                  style="width: 100%"
                  src="@/assets/img/home-yungis.png"
                  alt=""
                  @click="goPage('/YunGISWeb')"
                />
                <div class="home-yszt-tips" @click.stop>
              <div>煤炭地质云【云GIS】</div>
              <div class="more">
                <a
                  @click="goPage('/YunGISWeb')"
                  target="_blank"
                  style="color: #fff"
                  >导航到云GIS ></a
                >
              </div>
            </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div style="width: 38%">
            <div class="news-tab-nav" style="font-size:12px;">
              <span :class="[nIndex == 0 ? 'active' : '']" @click="nIndex = 0">新闻资讯</span>
              <span :class="[nIndex == 1 ? 'active' : '']" @click="nIndex = 1">供求信息</span>
              <span :class="[nIndex == 2 ? 'active' : '']" @click="nIndex = 2">通知公告</span>
              <span :class="[nIndex == 3 ? 'active' : '']" @click="nIndex = 3">知识共享</span>
              <span :class="[nIndex == 4 ? 'active' : '']" @click="nIndex = 4">知识库</span>
              <i @click="moreClick" v-show="nIndex<3">更多>></i>
            </div>
            <div class="home-news-list" v-show="nIndex == 0">
              <template v-for="(son, index) in tableNewData">
                <div v-if="index < 4" class="home-news-item" :key="son.ID">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/IndustryDynamic_detail',
                      query: { id: son.ID },
                    }"
                    style="display: flex"
                  >
                    <div class="home-news-date">
                      <span>{{ FormatDate(son.CreateTime, "D") }}</span
                      >{{ FormatDate(son.CreateTime, "NY") }}
                    </div>
                    <div class="home-news-right">
                      <div class="home-news-content">
                        <h6>{{ son.NewsTitle }}</h6>
                        <p v-html="son.NewsContent.replace(/<[^>]+>/g, '')">
                          <!-- {{ son.NewsContent.replace(/<[^>]+>/g, "") }} -->
                        </p>
                      </div>
                      <div class="home-news-more">详情>></div>
                    </div>
                  </router-link>
                </div>
              </template>
            </div>

            <div class="home-news-list" v-show="nIndex == 1">
              <template v-for="(son, index) in tableNeedData">
                <div v-if="index < 4" class="home-news-item" :key="son.ID">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/TradeLeads_detail',
                      query: { id: son.ID },
                    }"
                    style="display: flex"
                  >
                    <div class="home-news-date">
                      <span>{{ FormatDate(son.CreateTime, "D") }}</span
                      >{{ FormatDate(son.CreateTime, "NY") }}
                    </div>
                    <div class="home-news-right">
                      <div class="home-news-content">
                        <h6>{{ son.Title }}</h6>
                        <p v-html="son.FbContext">
                        </p>
                      </div>
                      <div class="home-news-more">详情>></div>
                    </div>
                  </router-link>
                </div>
              </template>
            </div>

            <div class="home-news-list" v-show="nIndex == 2">
              <template v-for="(item, index) in tableNoticeData">
                  <div v-if="index < 4" class="home-news-item" :key="item.ID">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/Notice_detail',
                      query: { id: item.ID },
                    }"
                    style="display: flex"
                  >
                    <div class="home-news-date news-date-dom">
                      <span>{{ FormatDate(item.CreateTime, "D") }}</span
                      >{{ FormatDate(item.CreateTime, "NY") }}
                    </div>
                    <div class="home-news-right">
                      <div class="home-news-content">
                        <h6>{{ item.NoticeTitle }}</h6>
                        <!-- <p>
                          <span>阅读量：11</span>
                        </p> -->
                      </div>
                      <div class="home-news-more">详情>></div>
                    </div>
                  </router-link>
                </div>
              </template>
            </div>

            <div class="home-news-list" v-show="nIndex == 3">
              <template v-for="(son, index) in tableKnowledgeData">
                <div v-if="index < 4" class="home-news-item" :key="son.ID">
                  <router-link
                    target="_blank"
                    :to="{
                      path: '/knowledge',
                    }"
                    style="display: flex"
                  >
                    <div class="home-news-date news-date-dom">
                      <span>{{ FormatDate(son.CreateTimeStr, "D") }}</span
                      >{{ FormatDate(son.CreateTimeStr, "NY") }}
                    </div>
                    <div class="home-news-right">
                      <div class="home-news-content">
                        <h6>{{ son.FileName }}</h6>
                        <p>
                          <span style="display: inline-block; width: 50%"
                            >类型：{{ shownewFileKind(son.FileKind) }}</span
                          >
                          <span>阅读量：{{ son.Readingvolume }}</span>
                        </p>
                      </div>
                      <div class="home-news-more">详情>></div>
                    </div>
                  </router-link>
                </div>
              </template>
            </div>

            <div class="home-news-list" v-show="nIndex == 4">
              <div style="position: relative">
                <img style="width: 100%" src="@/assets/img/zsk.png" alt="" />
                <div
                  style="
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(0, 0, 0, 0.3);
                  "
                >
                  <a
                    @click="goPage('/knowledgebase')"
                    target="_blank"
                    style="
                      color: #fff;
                      text-decoration: underline !important;
                      font-size: 1.6vw;
                    ">
                    知识库 >></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="video-banner">
      <div style="padding: 0 10%">
        <div style="display: flex; justify-content: space-between">
          <div style="width: 71.38%; position: relative">
            <div class="home-video-center">
              <h6>科普视频</h6>
              <span
                @click="
                  $router.push({ path: '/science', query: { tab: 'second' } })
                "
                >更多>></span
              >
            </div>
            <div style="position: relative">
              <video
                ref="video"
                src="https://www.coalgeocloud.com:31006/Upload/933ecdd758ad4ab28bcd6b75c41fcc54/煤炭的形成与利用.mp4"
                controls="controls"
                style="width: 100%"
              >
                您的浏览器不支持视频播放
              </video>
              <div
                style="
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  left: 0;
                  top: 0;
                "
                v-if="playBtnShow"
                @click="toggleVideoAction"
              >
                <div
                  style="
                    position: absolute;
                    color: #fff;
                    opacity: 0.5;
                    font-size: 2.5vw;
                    top: 50%;
                    left: 50%;
                    margin-top: -2.5vw;
                    margin-left: -2.5vw;
                    width: 5vw;
                    height: 5vw;
                    line-height: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    border: 0.4vw solid #fff;
                  "
                >
                  <i class="fa fa-play" style="margin-left: 0.6vw"></i>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 25.84%;display:flex;flex-direction:column;">
            <div class="home-video-center" style="height:10%;">
              <h6>科普人物</h6>
              <span @click="$router.push({ path: '/science' })">更多>></span>
            </div>
            <div style="background: #f2f2f2;flex:1; position:relative;">
              <el-carousel
                height="100%"
                indicator-position="none"
                  :interval="2000"
              >

                <el-carousel-item
                  v-for="item in tableSienceData"
                  :key="item.ID"

                >
                  <div >
                    <div
                      style="
                        margin: 3vw;
                        box-sizing: border-box;
                        height: 80%;
                        border-radius: 100%;
                        overflow: hidden;
                      "
                    >
                      <img
                        @click="
                          goPage({
                            name: 'sciencedetail',
                            query: { id: item.ID },
                          })
                        "
                        :src="item.VideoPath"
                        style="width: 100%; min-height: 100%"
                      />
                    </div>
                    <div class="home-video-people" style="position:absolute;bottom:3px;left:0;right:0;">
                      <router-link
                        target="_blank"
                        :to="{ name: 'sciencedetail', query: { id: item.ID } }"
                      >
                        {{ item.PeopleName }}</router-link
                      >
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ====== 实用工具 Start ====== -->
    <section class="services">
      <div class="pubTit" style="padding-bottom: 30px">
        <h2>实用工具</h2>
        <p>Utilities</p>
        <i></i>
      </div>
      <!-- <vue-seamless-scroll :data="UtilitiesList" :class-option="classOption" class="warp">
        <ul class="ul-item">
          <li class="li-item" v-for="son in UtilitiesList" v-bind:key="son.ID">
            <div class="item box-shadow">
              <a>
                <router-link :to="{ path: '/' + son.Href }" title="Web Development">
                  <div class="service_icon">
                    <img :src="son.Src" />
                  </div>
                  <div class="service_detail">
                    <h5>
                      {{ son.Title }}
                    </h5>
                    <p>
                      {{ son.Info }}
                    </p>
                  </div>
                </router-link>
              </a>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll> -->
      <el-carousel :loop="true" :autoplay="true" height="450px" class="warp">
        <el-carousel-item
          class="el-car-item"
          v-for="(list, index) in UtilitiesList"
          :key="index"
        >
          <ul class="ul-item">
            <li
              class="li-item"
              v-for="(imgList, index2) in list"
              :key="index2"
              style="float: left"
            >
              <div class="item box-shadow">
                <a>
                  <router-link
                    :to="{ path: '/' + imgList.Href }"
                    title="Web Development"
                  >
                    <div class="service_icon" style="height:247px;">
                      <img
                        class="top-img"
                        :src="imgList.Src"
                        :alt="imgList.Title"
                      />
                    </div>
                    <div class="service_detail">
                      <h5>
                        {{ imgList.Title }}
                      </h5>
                      <p>
                        {{ imgList.Info }}
                      </p>
                    </div>
                  </router-link>
                </a>
              </div>
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
    </section>
    <!-- ====== 实用工具 End ====== -->
    <!-- ====== HPC Start ====== -->
    <section class="computer">
      <div class="container-fluid">
        <!-- <div class="col-lg-3 col-md-3 col-xs-3 manageDom"> -->
        <div class="manageDom" style="width: 30%;">
          <div class="heading">
            <div class="top-line"></div>
            <h2 @click="$router.push('/ProjectInitiation')" style="cursor: pointer;">
              科研项目管理<span
                >Management of scientific research projects</span
              >
            </h2>
            <p
              v-for="(item, index) in manageList"
              :key="index"
              @click="$router.push(item.path)"
            >
              <a
                class="button--aylen"
                :style="{ '--styleColor': portalStyle }"
                >{{ item.title }}</a>
            </p>
            <!-- <a v-for="(item, index) in manageList" :key="index" @click="$router.push(item.path)">{{item.title}}</a> -->
          </div>
        </div>
        <!-- <div class="col-lg-9 col-md-9 col-xs-9" style="float: right"> -->
        <div style="float: right; width: 70%;">
          <div class="row box-row" style="flex-direction:nowrap">
            <div
              class="col-lg-6 col-md-12 col-sm-12 col-xs-12 animated bounceIn wow"
              style="padding-left: 60px;max-width:50%;"
            >
              <div class="img-sec">
                <img src="@/assets/img/HPC.png" style="padding-top:10%;"/>
              </div>
            </div>
            <span class="ball_a"></span>
            <span class="ball_b"></span>
            <span class="ball_c"></span>
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12" style="max-width:60%;">
              <div class="content-sec">
                <div class="heading">
                  <div class="top-line"></div>
                  <h2 @click="$router.push('/GCProjectManagement')" style="cursor: pointer;">
                    工程项目管理
                    <span>Geological exploration project management</span>
                    <!-- HPC高性能计算机<span>IHPC high performance computer</span> -->
                  </h2>
                </div>
                <p
                  v-for="(item, index) in surveyList"
                  :key="index"
                  @click="$router.push(item.path)"
                  class="surveyDom"
                >
                  <a
                    class="button--aylen"
                    :style="{ '--styleColor': portalStyle }"
                    >{{ item.title }}</a
                  >
                </p>
                <!-- <p>
                  地质报告的数据、资料具有多源、多类、多量、多主题的特点，在地质预查、普查、详查、勘探全过程中地质数据资料又具有动态更新的特征。
                  因此，地质报告的编制要使用复杂的地质基础资料，而且其重复利用率较高，在使用过程中又极易出现数据资料的丢失、重叠。
                  传统的手工处理地质资料方式和地质报告的编制模式已难以适应形势发展的需求。
                  实现地质资料的输入、管理、处理以及表格、文字的自动化生成，地质报告的智能化编制已成为地质行业的当前需求和未来需要。
                  通过煤炭地质云平台地质报告智能编制系统的应用，实现地质报告编制过程的智能化，缩短地质报告编制周期，提高报告的编制质量，具有明显的社会技术经济效益。
                </p> -->
              </div>
              <!-- <div class="buttons">
                <a href="" class="btn btn-primary mlr-5">了解更多</a>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ====== HPC End ====== -->

    <!-- ====== News Start ====== -->
    <!-- <section class="news">
      <div class="pubTit" style="padding-bottom: 50px">
        <h2>行业资讯</h2>
        <p>News</p>
        <i></i>
      </div>
      <router-link to="/IndustryDynamic_list">
        <div class="news-bg"></div>
      </router-link>
      <div class="xwcb" v-for="son in tableNewData" v-bind:key="son.ID">
        <router-link
          target="_blank"
          :to="{
            path: '/IndustryDynamic_detail',
            query: { id: son.ID }
          }"
        >
          <div class="xwcb_a">
            <span>{{ FormatDate(son.CreateTime, "D") }}</span
            >{{ FormatDate(son.CreateTime, "NY") }}
          </div>
          <div class="xwcb_b">
            <h6>{{ son.NewsTitle }}</h6>
            <p>
              {{ son.NewsContent.replace(/<[^>]+>/g, "") }}
            </p>
          </div>
          <div class="xwcb_c">
            <img src="@/assets/img/d10.png" alt="" />
            <img src="@/assets/img/d10-1.png" alt="" />
          </div>
          <div class="clearfix"></div>
        </router-link>
      </div>
    </section> -->

    <!-- ====== News End ====== -->

    <section class="qualities border-b">
      <div class="container-fluid item-flex">
        <!-- 左侧 -->
        <div class="item-flex-left">
          <div class="pubTit" style="padding-bottom: 0">
            <h2>地质特征在线查询 <small>GEOLOGICAL INQUIRY</small></h2>
            <div class="des">
              可为您提供快速定位查询区域，欢迎通过本平台共享您的相关知识
            </div>
          </div>
          <div class="item-flex-left-content">
            <div class="item-flex-left-cricle">
              <img
                src="@/assets/img/home_service_center.png"
                alt=""
                class="service-center"
              />
              <img
                src="@/assets/img/home_service_center2.png"
                alt=""
                class="service-center2"
              />
              <ul class="flex-item-ul">
                <li>
                  <div>
                    <router-link
                      target="_blank"
                      :to="{
                        path: '/GeologicalQuery',
                        query: { typename: '区域地质特征' },
                      }"
                    >
                      <i class="iconfont iconfabu"></i>
                      <div class="flex-item-des">
                        <p>区域地质特征</p>
                        <p>区域地层、区域构造、区域地震</p>
                      </div>
                    </router-link>
                  </div>
                </li>
                <li>
                  <div>
                      <router-link
                      target="_blank"
                      :to="{
                        path: '/GeologicalQuery',
                        query: { typename: '区域水文地质特征' },
                      }"
                    >
                    <i class="iconfont iconshuxiebi"></i>

                    <div class="flex-item-des">
                      <p>区域水文地质特征</p>
                      <p>
                        地表水系、区域含（隔）水层水文地质特征、地下水补、径、排条件、区域地下水水化学特征
                      </p>
                    </div>
                     </router-link>
                  </div>
                </li>
                <li>
                  <div>
                     <router-link
                      target="_blank"
                      :to="{
                        path: '/GeologicalQuery',
                        query: { typename: '环境地质特征' },
                      }"
                    >
                    <i class="iconfont icon71"></i>

                    <div class="flex-item-des">
                      <p>环境地质特征</p>
                    </div>
                         </router-link>
                  </div>
                </li>
                <li>
                  <div>
                       <router-link
                      target="_blank"
                      :to="{
                        path: '/GeologicalQuery',
                        query: { typename: '灾害地质特征' },
                      }"
                    >
                    <i class="iconfont iconshouji"></i>
                    <div class="flex-item-des">
                      <p>灾害地质特征</p>
                    </div>
                      </router-link>
                  </div>
                </li>
                <li>
                  <div>
                     <router-link
                      target="_blank"
                      :to="{
                        path: '/GeologicalQuery',
                        query: { typename: '灾害地质特征' },
                      }"
                    >
                    <i class="iconfont iconxiongzhang"></i>
                       <div class="flex-item-des">
                      <p>自然地理</p>
                      <p>交通、地形地貌、地形地貌、人文经济</p>
                    </div>
                      </router-link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <p style="text-align: center">
            <router-link
              to="/GeologicalQuery"
              class="btn btn-primary mlr-5 get-more-info-btn"
              >了解更多>>
            </router-link>
          </p>
        </div>
        <!-- 右侧 -->
        <div class="item-flex-right">
          <div class="pubTit" style="padding-bottom: 0">
            <h2>
              地质报告辅助编制
              <small>INTELLIGENT COMPILATION OF GEOLOGICAL REPORT</small>
            </h2>
            <div class="des">
              地质报告的数据、资料具有多源、多类、多量、多主题的特点，在地质预查、普查、详查、勘探全过程中地质数据资料又具有动态更新的特征。
              因此，地质报告的编制要使用复杂的地质基础资料，而且其重复利用率较高，在使用过程中又极易出现数据资料的丢失、重叠。
              传统的手工处理地质资料方式和地质报告的编制模式已难以适应形势发展的需求。
              实现地质资料的输入、管理、处理以及表格、文字的自动化生成，地质报告的智能化编制已成为地质行业的当前需求和未来需要。
              通过煤炭地质云平台地质报告智能编制系统的应用，实现地质报告编制过程的智能化，缩短地质报告编制周期，提高报告的编制质量，具有明显的社会技术经济效益。
            </div>
          </div>
          <div class="item-flex-right-content">
            <div
              class="item-flex-right-btn"
              v-for="(i, k) in ICOGRList"
              :key="k"
            >
              <a
                v-on:click="openNewWeb(i.title)"
                class="button button--aylen"
                :style="{ '--styleColor': portalStyle }"
              >
                <p>
                  <i
                    class="iconfont"
                    :class="i.icon"
                    :style="{ color: portalStyle }"
                  ></i>
                </p>
                <p>{{ i.title }}</p>
              </a>
            </div>
          </div>
          <p style="text-align: center">
            <router-link
              to="/GeologicalReport/AuxiliaryEstablishmentList"
              class="btn btn-primary mlr-5 get-more-info-btn"
              >编制报告
            </router-link>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  getNewList,
  GetNoticeList,
  getCarouselSlideList,
  getUtilitiesList,
  getGeologicalfeatureList,
} from "@/api/Index";
import { PopularsciencePepole } from "@/api/science";
import { getXQFBList } from "@/api/TradeLeads_api";
import { getList } from "@/api/Knowledgeapi";

import "@/assets/js/jquery-2.1.1.min.js";
import "@/assets/css/mycss/style.css";
import "@/assets/css/mycss/default.css";
import "@/assets/font/iconfont.css";
import "@/assets/css/mycss/index.css";
import "@/assets/css/mycss/owl.carousel.min.css";
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: "Example03Basic",
  data() {
    return {
      portalStyle: "",
    };
  },
  components: {
    vueSeamlessScroll,
  },
  created() {
    this.portalStyle = "";
    if (this.$store.getters.sitestyle == "red") {
      this.portalStyle = "#be4949";
    } else if (this.$store.getters.sitestyle == "gray") {
      this.portalStyle = "gray";
    } else {
      this.portalStyle = "#007bff";
    }
  },
  mounted() {

    this.loadNewData();
    this.loadCarouselSlide();
    this.loadUtilities();
    this.loadGeologicalfeature();
  },
  data() {
    return {
      playBtnShow: true,
      nIndex: 0,
      caption: "caption",
      listData: [1, 2, 3, 4, 5, 6],
      tableNewData: [],
      tableNoticeData:[],
      tableNeedData: [],
      tableSienceData: [],
      tableKnowledgeData: [],
      // noticeData: [
      //   {
      //     ID: "1",
      //     CreateTime: "2022-12-01",
      //     name: '关于举办"第四届绿色勘查科技论坛"的第2号通知'
      //   },
      //   {
      //     ID: "2",
      //     CreateTime: "2022-10-12",
      //     name: '关于举办“第四届绿色勘查科技论坛”的通知'
      //   },
      //   {
      //     ID: "3",
      //     CreateTime: "2020-07-29",
      //     name: '重点实验室开放研究课题申报指南（2021年度）'
      //   },
      //   {
      //     ID: "4",
      //     CreateTime: "2019-12-26",
      //     name: '自然资源部煤炭资源勘查与综合利用重点实验室 2019年固定研'
      //   }
      // ], // 通知公告列表
      classOption: {
        limitMoveNum: 2,
        switchSingleStep: 140,
        direction: 3,
      },
      CarouselSlideList: [],
      UtilitiesList: [],
      GeologicalfeatureList: [],
      ICOGRList: [
        {
          title: "地质",
          icon: "icondizhi1",
        },
        {
          title: "水文地质",
          icon: "iconshuiwen",
        },
        {
          title: "工程地质",
          icon: "icongongcheng",
        },
        {
          title: "环境地质",
          icon: "iconhuanjing",
        },
        {
          title: "灾害地质",
          icon: "iconzaihai",
        },
        {
          title: "煤质",
          icon: "icon184meizhifenxi",
        },
        {
          title: "采样测试",
          icon: "iconcaiyangji",
        },
        {
          title: "测量",
          icon: "iconceliang",
        },
        {
          title: "地球物理测井",
          icon: "icondiqiu",
        },
        {
          title: "地震勘探",
          icon: "icondizhen",
        },
        {
          title: "电法",
          icon: "icondibandianfa",
        },
        {
          title: "磁法",
          icon: "iconcili",
        },
        {
          title: "钻探",
          icon: "iconzuantanfa",
        },
        {
          title: "槽探",
          icon: "iconcaoyekongzhixiangmuguanli",
        },
        {
          title: "坑探",
          icon: "iconkengtangongcheng",
        },
      ],
      manageList: [
        {
          title: "申报管理",
          path: "/ProjectInitiation",
        },
        {
          title: "合同管理",
          path: "/ContractList",
        },
        {
          title: "项目进展",
          path: "/Implementation",
        },
        {
          title: "项目验收",
          path: "/ProjectAcceptance",
        },
      ],
      surveyList: [
        {
          title: "我的项目",
          path: "/GCProjectManagement",
        },
        {
          title: "生产调度",
          path: "/Industries",
        },
        {
          title: "项目工作周报上报",
          path: "/ProjectWorkReport",
        },
        {
          title: "项目评审",
          path: "/ProjectReviewList",
        },
        {
          title: "项目验收",
          path: "/ProjectCheckAcceptanceList",
        },
        {
          title: "项目管理驾驶舱",
          path: "/ProjectOneDrawing",
        },
        // {
        //   title: "项目创建",
        //   path: "/GCProjectManagement",
        // },
        // {
        //   title: "项目技术管理",
        //   path: "/ProjectTechnology",
        // },
        // {
        //   title: "项目技术管理视图",
        //   path: "/ProjectTeChnicalViewList",
        // },
        // {
        //   title: "项目统计",
        //   path: "/ProjectWeeklyReport",
        // },
        // {
        //   title: "项目工作周报上报",
        //   path: "/ProjectWorkReport",
        // },
        // {
        //   title: "项目验收",
        //   path: "/ProjectCheckAcceptanceList",
        // },
        // {
        //   title: "项目评审",
        //   path: "/ProjectReviewList",
        // },
        // {
        //   title: "项目管理驾驶舱",
        //   path: "/ProjectOneDrawing",
        // },
      ],
    };
  },
  methods: {
    goPage(route) {
      if (typeof route == "string") {
        window.open(route, "_blank");
        return false;
      }
      let { href } = this.$router.resolve(route);
      window.open(href, "_blank");
    },
    moreClick() {
      if(this.nIndex == 0) { // 新闻资讯
        this.$router.push("/IndustryDynamic_list")
      } else if(this.nIndex == 1) { // 供求信息
        this.$router.push("/TradeLeads_list")
      } else if(this.nIndex == 2) { // 通知公告
        this.$router.push("/Notice_list")
      }
    },
    toggleVideoAction() {
      if (this.playBtnShow) {
        this.playBtnShow = false;
        let v = this.$refs.video;
        v.play();
      }
    },
    shownewFileKind(ogStr) {
      let newStrHtml = "";
      let appnewstr = "";
      if (ogStr == "1") {
        appnewstr = "文档";
      }
      if (ogStr == "2") {
        appnewstr = "视频";
      }
      if (ogStr == "3") {
        appnewstr = "音频";
      }
      if (appnewstr != "") {
        newStrHtml = `${appnewstr}`;
      }
      return newStrHtml;
    },
    initimg() {
      let newDataList = [];
      let current = 0;
      if (this.UtilitiesList && this.UtilitiesList.length > 0) {
        for (let i = 0; i <= this.UtilitiesList.length - 1; i++) {
          if (i % 4 !== 0 || i === 0) {
            if (!newDataList[current]) {
              newDataList.push([this.UtilitiesList[i]]);
            } else {
              newDataList[current].push(this.UtilitiesList[i]);
            }
          } else {
            current++;
            newDataList.push([this.UtilitiesList[i]]);
          }
        }
      }
      if (newDataList.length > 0) {
        var j = newDataList.length - 1;

        if (newDataList[j].length < 4) {
          for (let k = 0; k <= this.UtilitiesList.length; k++) {
            if (newDataList[j].length < 4) {
              newDataList[j].push(this.UtilitiesList[k]);
            }
          }
        }
      }

      this.UtilitiesList = [...newDataList];
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    loadUtilities() {
      getUtilitiesList().then((res) => {
        if (res.Code === 200) {
          this.UtilitiesList = res.Data;
          this.initimg();
          // this.$refs.seamlessScroll.reset();
        }
      });
    },
    loadGeologicalfeature() {
      getGeologicalfeatureList().then((res) => {
        if (res.Code === 200) {
          this.GeologicalfeatureList = res.Data;
        }
      });
    },
    loadCarouselSlide() {
      getCarouselSlideList().then((res) => {
        if (res.Code === 200) {
          this.CarouselSlideList = res.Data;
        }
      });
    },
    loadNewData() {
      getNewList({}).then((res) => {
        if (res.Code === 200) {
          this.tableNewData = res.Data;
        } else {
          this.tableNewData = [];
        }
      });

      getXQFBList({
        PageIndex: 1,
        PageSize: 7,
        total: 0,
      }).then((res) => {
        if (res.Code === 200) {
          this.tableNeedData = res.Data.rows;
        } else {
          this.tableNeedData = [];
        }
      });

      PopularsciencePepole().then((res) => {
        if (res.Code === 200) {
          this.tableSienceData = res.Data;
        } else {
          this.tableSienceData = [];
        }
      });

      getList({
        PageIndex: 1,
        PageSize: 7,
        total: 0,
        parentID: "",
        key: "",
        type: "",
        index:"1"
      }).then((res) => {
        if (res.Code === 200) {
          this.tableKnowledgeData = res.Data.rows;
        } else {
          this.tableKnowledgeData = [];
        }
      });

      GetNoticeList({}).then((res) => {
          if (res.Code === 200) {
            this.tableNoticeData = res.Data;
          } else {
            this.tableNoticeData = [];
          }
        });
    },

    FormatDate(date, type) {
      if (date != null) {
        if (type == "D") {
          if(date.length > 10) {
            return date.split(" ")[0].split("/")[2];
          } else {
            return date.substr(Number(date.length - 2), 2);
          }

        }
        if (type == "NY") {
          if(date.length > 10) {
            var nyr = date.split(" ")[0].split("/");
            return nyr[0] + "." + nyr[1];
          } else{
            return date.substr(0, Number(date.length - 3));
          }

        }
      }
    },
    openNewWeb(title) {
       this.$router.push({
            path: "/GeologicalReport/AuxiliaryEstablishmentList",
            query: {
              title: title,
            },
          });
      // debugger;
      // switch (title) {
      //   case "煤质":
      //     this.$router.push({
      //       path: "/GeologicalReport/AuxiliaryEstablishmentList",
      //       query: {
      //         title: title,
      //       },
      //     });
      //     break;
      //   default:
      //     this.$router.push({
      //       path: "/GeologicalReport/AuxiliaryEstablishmentList",
      //       query: {
      //         title: title,
      //       },
      //     });
      //     break;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.warp {
  width: 390px * 4;
  height: 580px;
  height: 450px;
  margin: 0 auto;
  overflow: hidden;

  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;

    &.ul-item {
      display: flex;
      margin-bottom: 10%;

      .li-item {
        width: 30%;
        height: 100%;
        margin-left: 15px;
      }
    }
  }
}
.box-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}
.carousel-control-next-icon,
.carousel-control-prev-icon {
  width: 40px;
  height: 40px;
}

.border-b {
  border-bottom: 1px solid #eee;
}
/deep/ .el-carousel--horizontal {
  height: 100%;
}
.item-flex {
  display: flex;
  justify-content: space-between;

  .pubTit h2 {
    text-align: left;
    font-size: 24px;
    padding-bottom: 10px;
    color: #000;

    small {
      font-size: 14px;
      color: #888;
      padding-left: 10px;
    }
  }

  .des {
    text-align: left;
    line-height: 2;
    font-size: 14px;
    margin-top: 0;
  }

  .item-flex-left {
    flex-shrink: 0;
    width: 500px;
    padding: 10px;
    position: relative;
    z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
    .item-flex-left-content {

    margin: 2% auto;
    width: 50%;
    height: 60%;


      .item-flex-left-cricle {
        width: 100%;
        height: 100%;
        position: relative;
        border: 1px solid #07b4e9;
        border-radius: 100%;

        .service-center {
          width: 100%;
          height: 100%;
          animation: ripple 2s ease-out infinite;
        }

        .service-center2 {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          animation: cromate 50s ease-out infinite;
        }
      }
    }
  }

  .item-flex-right {
    display: block;
    flex: 1;
    flex-basis: auto;
    padding: 10px;
  }
}

.flex-item-ul {
  li {
    position: absolute;
    left: calc(50% - 20px);
    top: -20px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #07b4e9;
    border-radius: 100%;
    transform-origin: 20px 220px;
    cursor: pointer;

    div {
      width: 100%;
      height: 100%;
      position: relative;

      i {
        font-size: 18px;
        color: #fff;
        animation: xpf 2s ease-out infinite;
        // font-weight: bold;
        // vertical-align: middle;
      }
    }

    .flex-item-des {
      position: absolute;
      transform-origin: top left;
      left: 0;
      top: 0;
      width: 200px;
      padding: 6px 10px;
      border-radius: 4px;
      background: #07b4e9;
      text-align: left;
      color: #fff;
      height: auto;
      width: 200px;
      overflow: hidden;
      display: none;

      // transition: all 0.5s ease;
      p {
        color: #fff;
      }

      p:nth-child(1) {
        font-size: 14px;
      }

      p:nth-child(2) {
        font-size: 12px;
        line-height: 1.2;
      }
    }
  }

  @for $i from 1 through 5 {
    li:nth-of-type(#{$i}) {
      transform: rotate(($i - 1) * 72 + deg);

      .flex-item-des {
        transform: rotate(($i - 1) * -72 + deg);
      }
    }
  }

  li:nth-child(1) {
    .flex-item-des {
      left: 50px;
      top: 10px;
    }
  }

  li:nth-child(2) {
    .flex-item-des {
      left: 30px;
      top: -10px;
    }
  }

  li:nth-child(5) {
    .flex-item-des {
      left: 90px;
      top: 20px;
    }
  }
}

.flex-item-ul li:hover .flex-item-des {
  display: block;
  animation: hideIndex 0.5s;
}

@keyframes xpf {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }

  100% {
    opacity: 1;
  }
}

@keyframes hideIndex {
  0% {
    opacity: 0;
    height: 0;
    // transform: translate(800px, 0);
  }

  100% {
    opacity: 1;
    height: auto;
    // transform: translate(0, 0);
  }
}

.item-flex-right-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

/* Aylen */
.button.button--aylen {
  background: #fff;
  color: #37474f;
  overflow: hidden;
  -webkit-transition: color 0.3s;
  transition: color 0.3s;
  position: relative;
}

.button--aylen.button--inverted {
  background: none;
  color: #fff;
}

.button--aylen::before,
.button--aylen::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 100%;
  left: 0;
  z-index: -1;
  -webkit-transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  -webkit-transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
  transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
}

.button--aylen::before {
  background: var(--styleColor);
}

.button--aylen::after {
  background: var(--styleColor);
}

.button--aylen:hover {
  color: #fff;

  p {
    color: #fff;

    i {
      color: #fff !important;
    }
  }
}

.button--aylen:hover::before,
.button--aylen:hover::after {
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

.button--aylen:hover::after {
  -webkit-transition-delay: 0.175s;
  transition-delay: 0.175s;
}

.item-flex-right-btn {
  margin: 10px;
  width:15%;
  a {
    float: left;
    min-width: 100%;
    display: block;
    margin: 1em;
    padding: 1em 0;
    border: none;
    background: none;
    color: inherit;
    vertical-align: middle;
    position: relative;
    z-index: 1;
    -webkit-backface-visibility: hidden;
    -moz-osx-font-smoothing: grayscale;
    border: solid 1px #e6e6e6;
    border-radius: 5px;
    box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1),
      0 0 4px 0 rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1),
      0 0 4px 0 rgba(0, 0, 0, 0.1);

    p {
      text-align: center;

      i {
        font-size: 20px;
        color: #be4949;
      }
    }
  }
}

.get-more-info-btn {
  color: #fff;
  padding: 10px 40px;
  border-radius: 50px;
}

.manageDom {
  background: rgba(255, 255, 255, 0.1);
  float: left;
  // box-shadow: 0 1px 4px 0 rgba(0 0 0 / 30%);
}

.manageDom .heading {
  text-align: left;
}

.manageDom .top-line {
  float: left;
  width: 20%;
  margin-bottom: 15px;
  border-radius: 5px;
}

.manageDom h2,
.heading h2 {
  clear: both;
  padding-bottom: 25px;
}

.manageDom p {
  width: 58%;
  height: 3.5rem;
  position: relative;
  float: left;
  margin: 10px 0px;
  overflow: hidden;
}

.manageDom a,
.surveyDom a {
  width: 100%;
  height: 3.5rem;
  overflow: hidden;
  color: #37474f;
  text-align: center;
  line-height: 3.5rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1),
    0 0 4px 0 rgba(0, 0, 0, 0.1);
  font-size: 16px;
  -webkit-transition: color 0.3s;
  transition: color 0.3s;
  display: block;
  z-index: 1;
}

.manageDom a::before,
.manageDom a::after,
.surveyDom a::before,
.surveyDom a::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 100%;
  overflow: hidden;
  border-radius: 5px;
  left: 0;
  z-index: -1;
  -webkit-transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  -webkit-transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
  transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
}

.manageDom a::before,
.surveyDom a::before {
  background: var(--styleColor);
  // background: rgba(174, 28, 28, 0.5);
}

.manageDom a::after,
.surveyDom a::after {
  background: var(--styleColor);
  // background: rgba(174, 28, 28, 0.8);
}

.manageDom a:hover,
.surveyDom a:hover {
  color: #fff;
  background: none;
}

.manageDom a:hover::before,
.manageDom a:hover::after,
.surveyDom a:hover::before,
.surveyDom a:hover::after {
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

.manageDom a:hover::after,
.surveyDom a:hover::after {
  -webkit-transition-delay: 0.175s;
  transition-delay: 0.175s;
}

.surveyDom {
  width: 40%;
  height: 3.5rem;
  position: relative;
  float: left;
  margin: 10px 10px !important;
  overflow: hidden;
  text-align: center !important;
  text-indent: 0rem;
}

/deep/ .swiperDom, /deep/ .swiperDom .el-carousel__container{
  width: 100%;
  height: 440px;
}
/deep/ .swiperDom img{
  max-width: 100%;
  height: auto;
}
.news-date-dom{
    padding: 12px 7px !important;
    width: 71px !important;
    height: 61px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/Index.vue